import React  , {useState} from 'react'
import { NavLink } from 'react-router-dom'
import './cssBoiler.css'
import './Navbar.css'
import Ham from './assets/ham.png'
import Cross from './assets/cross.png'
// LOGO 
import Logo from './assets/logo.png'
function Navbar() {

  const [mobileNav, setMobileNav] = useState({
    top:'-500px',
    icon: Ham
  })

  const [isNavOpen, setIsNavOpen] = useState(false);
  const [icon, setIcon] = useState(Ham);
  const [navChange, setNavChange] = useState(false);

  const navToggle = () => {
    if(isNavOpen == false) {
      setMobileNav({top: '80px'})
      setIsNavOpen(true)
      setIcon(Cross)
    }
    else {
      setMobileNav({top: '-500px'})
      setIsNavOpen(false)
      setIcon(Ham)
     
    }
  }

  const navChanger = () => {
    if(window.scrollY >= 600) {
      setNavChange(true)

    }
    else {
      setNavChange(false);
    }
  }
  const mobileNavController = () => {
    setMobileNav({top: '-500px'})
      setIsNavOpen(false)
      setIcon(Ham)
  }

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId.replace("#", ""));
    if (element) {
      // Use the global Locomotive Scroll instance
      if (window.locomotiveScrollInstance) {
        window.locomotiveScrollInstance.scrollTo(element);
      } else {
        // Fallback to native scroll
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  window.addEventListener("scroll", navChanger);
  return (
    <div>
      <nav className="container-fluid navB">
        <div className={navChange ? "center-nav active" : "center-nav"}>
          <img src={Logo} alt="" className="logo" width="200" />
          {/* PC UL  */}
          <ul className="navItems">
            <li>
              <a
                href="#header-home"
                className="links"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection("#header-home");
                }}
              >
                Home
              </a>
            </li>
            <li>
              <a
                href="#projects"
                className="links"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection("#projects");
                }}
              >
                Projects
              </a>
            </li>
            <li>
              <a
                href="#skills"
                className="links"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection("#skills");
                }}
              >
                Skills
              </a>
            </li>
            <li>
              <a
                href="#about"
                className="links"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection("#about");
                }}
              >
                About
              </a>
            </li>
            <li>
              <a
                href="#hire-me"
                className="links"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection("#hire-me");
                }}
              >
                Contact
              </a>
            </li>
            <div className="ham">
              <img src={icon} alt="error" width="30" onClick={navToggle} />
            </div>
          </ul>
        </div>
        {/* MOBILE UL  */}
        <div className="mobileNav" style={mobileNav}>
          <ul className="mobileNavItems">
            <li>
              <a
                href="#header-home"
                className="links2"
                onClick={(e) => {
                  e.preventDefault();
                  mobileNavController();
                  scrollToSection("#header-home");
                }}
              >
                Home
              </a>
            </li>
            <li>
              <a
                href="#projects"
                className="links2"
                onClick={(e) => {
                  e.preventDefault();
                  mobileNavController();
                  scrollToSection("#projects");
                }}
              >
                Projects
              </a>
            </li>
            <li>
              <a
                href="#skills"
                className="links2"
                onClick={(e) => {
                  e.preventDefault();
                  mobileNavController();
                  scrollToSection("#skills");
                }}
              >
                Skills
              </a>
            </li>
            <li>
              <a
                href="#about"
                className="links2"
                onClick={(e) => {
                  e.preventDefault();
                  mobileNavController();
                  scrollToSection("#about");
                }}
              >
                About
              </a>
            </li>
            <li>
              <a
                href="#hire-me"
                className="links2"
                onClick={(e) => {
                  e.preventDefault();
                  mobileNavController();
                  scrollToSection("#hire-me");
                }}
              >
                Contact
              </a>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  );
}

export default Navbar